import { ConditionShape, ConditionStatus } from "@eave/shared/types/api";

import { operatorIdFromToken } from "web_modules/shared/session";

// the forward progression of condition status is:
// Open -> Requested -> Received -> ReadyToReview -> (Cleared | NotApplicable)

// moving back a status means the data points of subsequent statuses
// should be cleared, since they no longer reflect current condition state.
export function clearSubsequentConditionDataPoints(condition: ConditionShape): ConditionShape {
  const updatedCondition = { ...condition };

  if (updatedCondition.status === ConditionStatus.Open) {
    updatedCondition.requested_date = null;
  }
  if (
    updatedCondition.status === ConditionStatus.Open ||
    updatedCondition.status === ConditionStatus.Requested
  ) {
    updatedCondition.received_date = null;
  }
  if (
    updatedCondition.status === ConditionStatus.Open ||
    updatedCondition.status === ConditionStatus.Requested ||
    updatedCondition.status === ConditionStatus.Received ||
    updatedCondition.status === ConditionStatus.ReadyToReview
  ) {
    updatedCondition.resolved_at = null;
    updatedCondition.resolved_by_email = null;
    updatedCondition.resolved_by_id = null;
  }

  return updatedCondition;
}

export function changeConditionStatus(
  nowMomentTimezone: any,
  sessionToken: string,
  condition: ConditionShape,
  status: ConditionStatus,
): ConditionShape {
  const operatorID = operatorIdFromToken(sessionToken);

  let changes: any = {
    status,
    status_updated_at: nowMomentTimezone,
    status_updated_by_id: operatorID,
    status_updated_by_email: null,
  };

  const today = nowMomentTimezone.tz("America/Los_Angeles").format("YYYY-MM-DD");

  if (status === ConditionStatus.Requested) {
    changes = {
      ...changes,
      requested_date: today,
    };
  } else if (status === ConditionStatus.Received) {
    changes = {
      ...changes,
      received_date: today,
    };
  } else if (status === ConditionStatus.Cleared || status === ConditionStatus.NotApplicable) {
    changes = {
      ...changes,
      resolved_at: nowMomentTimezone,
      resolved_by_id: operatorID,
      resolved_by_email: null,
    };
  }

  const updatedCondition = clearSubsequentConditionDataPoints({ ...condition, ...changes });

  return updatedCondition;
}
